import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import DataGrid from "@poseidon/ui/components/DataGrid";
import { DataGridContainer } from "@poseidon/ui/components/DataGridContainer";
import { getColumnDefinition } from "./getColumnDefinition";
import { useAgreements } from "../hooks/useAgreements";
import { CircularProgress } from "@mui/material";

export default function ListAgreements() {
  const { setError } = useErrorMessage();
  const columns = getColumnDefinition();
  const { agreements, loading, error } = useAgreements();

  if (error) {
    setError(error);
  }
  if (loading || !agreements) {
    return <CircularProgress sx={{ alignSelf: "center" }} />;
  }
  return (
    <DataGridContainer>
      <DataGrid
        useSessionStorageForPagination
        id="agreements"
        columns={columns}
        rows={agreements}
        setError={setError}
        doubleClickSlug="agreements"
      />
    </DataGridContainer>
  );
}
